import React from "react";
import { motion } from "framer-motion";

function Logo() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 2, delay: 0.5 }}
      className="flex water"
    >
      <img className="max-w-[240px]" src="/image/A4.png" alt="logo" loading="lazy" />
    </motion.div>
  );
}

export default Logo;
